import { HouseIcon as PhosphorHouseIcon } from "@phosphor-icons/react/dist/ssr/House";

import { createAppIcon } from "@/components/createAppIcon";

export const HomeIcon = /* @__PURE__ */ createAppIcon(PhosphorHouseIcon);
export const HomeFilledIcon = /* @__PURE__ */ createAppIcon(PhosphorHouseIcon, "fill");
